import { crossCircle } from "@/designSystemIcons";
import { useTranslation } from "@repo/shared/i18n";

export const SafariUpdateRequired = () => {
  const { t } = useTranslation("clubImport");
  return (
    <div className="bg-panel-base min-h-screen px-4 py-6">
      <h1 className="text-white text-lg font-bold mb-2">{t("mobile.title")}</h1>
      <p className="text-dark-secondary text-sm mb-6">{t("mobile.subtitle")}</p>

      <div className="bg-panel-background border border-new-gray-700 rounded-[15px] p-4 flex flex-col gap-2.5">
        <div className="flex items-center gap-2.5">
          <div className="w-5 h-5 rounded-full bg-white/75">{crossCircle}</div>
          <h2 className="text-white text-sm font-bold">
            {t("mobile.safariUpdate.title")}
          </h2>
        </div>

        <div className="flex flex-col gap-5">
          <p className="text-white text-sm leading-5">
            {t("mobile.safariUpdate.body")}
          </p>
        </div>
      </div>
    </div>
  );
};
